function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import StringBuffer from '../../../../java/lang/StringBuffer';
import Double from '../../../../java/lang/Double';
import Integer from '../../../../java/lang/Integer';
import Character from '../../../../java/lang/Character';
import Comparable from '../../../../java/lang/Comparable';
import Cloneable from '../../../../java/lang/Cloneable';
import Serializable from '../../../../java/io/Serializable';
var DD = /*#__PURE__*/function () {
  function DD() {
    _classCallCheck(this, DD);
    DD.constructor_.apply(this, arguments);
  }
  return _createClass(DD, [{
    key: "le",
    value: function le(y) {
      return this._hi < y._hi || this._hi === y._hi && this._lo <= y._lo;
    }
  }, {
    key: "extractSignificantDigits",
    value: function extractSignificantDigits(insertDecimalPoint, magnitude) {
      var y = this.abs();
      var mag = DD.magnitude(y._hi);
      var scale = DD.TEN.pow(mag);
      y = y.divide(scale);
      if (y.gt(DD.TEN)) {
        y = y.divide(DD.TEN);
        mag += 1;
      } else if (y.lt(DD.ONE)) {
        y = y.multiply(DD.TEN);
        mag -= 1;
      }
      var decimalPointPos = mag + 1;
      var buf = new StringBuffer();
      var numDigits = DD.MAX_PRINT_DIGITS - 1;
      for (var i = 0; i <= numDigits; i++) {
        if (insertDecimalPoint && i === decimalPointPos) {
          buf.append('.');
        }
        var digit = Math.trunc(y._hi);
        if (digit < 0 || digit > 9) {}
        if (digit < 0) {
          break;
        }
        var rebiasBy10 = false;
        var digitChar = 0;
        if (digit > 9) {
          rebiasBy10 = true;
          digitChar = '9';
        } else {
          digitChar = '0' + digit;
        }
        buf.append(digitChar);
        y = y.subtract(DD.valueOf(digit)).multiply(DD.TEN);
        if (rebiasBy10) y.selfAdd(DD.TEN);
        var continueExtractingDigits = true;
        var remMag = DD.magnitude(y._hi);
        if (remMag < 0 && Math.abs(remMag) >= numDigits - i) continueExtractingDigits = false;
        if (!continueExtractingDigits) break;
      }
      magnitude[0] = mag;
      return buf.toString();
    }
  }, {
    key: "sqr",
    value: function sqr() {
      return this.multiply(this);
    }
  }, {
    key: "doubleValue",
    value: function doubleValue() {
      return this._hi + this._lo;
    }
  }, {
    key: "subtract",
    value: function subtract() {
      if (arguments[0] instanceof DD) {
        var y = arguments[0];
        return this.add(y.negate());
      } else if (typeof arguments[0] === 'number') {
        var _y = arguments[0];
        return this.add(-_y);
      }
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments.length === 1 && arguments[0] instanceof DD) {
        var y = arguments[0];
        return this._hi === y._hi && this._lo === y._lo;
      }
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return this._hi === 0.0 && this._lo === 0.0;
    }
  }, {
    key: "selfSubtract",
    value: function selfSubtract() {
      if (arguments[0] instanceof DD) {
        var y = arguments[0];
        if (this.isNaN()) return this;
        return this.selfAdd(-y._hi, -y._lo);
      } else if (typeof arguments[0] === 'number') {
        var _y2 = arguments[0];
        if (this.isNaN()) return this;
        return this.selfAdd(-_y2, 0.0);
      }
    }
  }, {
    key: "getSpecialNumberString",
    value: function getSpecialNumberString() {
      if (this.isZero()) return '0.0';
      if (this.isNaN()) return 'NaN ';
      return null;
    }
  }, {
    key: "min",
    value: function min(x) {
      if (this.le(x)) {
        return this;
      } else {
        return x;
      }
    }
  }, {
    key: "selfDivide",
    value: function selfDivide() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof DD) {
          var y = arguments[0];
          return this.selfDivide(y._hi, y._lo);
        } else if (typeof arguments[0] === 'number') {
          var _y3 = arguments[0];
          return this.selfDivide(_y3, 0.0);
        }
      } else if (arguments.length === 2) {
        var yhi = arguments[0];
        var ylo = arguments[1];
        var hc = null;
        var tc = null;
        var hy = null;
        var ty = null;
        var C = null;
        var c = null;
        var U = null;
        var u = null;
        C = this._hi / yhi;
        c = DD.SPLIT * C;
        hc = c - C;
        u = DD.SPLIT * yhi;
        hc = c - hc;
        tc = C - hc;
        hy = u - yhi;
        U = C * yhi;
        hy = u - hy;
        ty = yhi - hy;
        u = hc * hy - U + hc * ty + tc * hy + tc * ty;
        c = (this._hi - U - u + this._lo - C * ylo) / yhi;
        u = C + c;
        this._hi = u;
        this._lo = C - u + c;
        return this;
      }
    }
  }, {
    key: "dump",
    value: function dump() {
      return 'DD<' + this._hi + ', ' + this._lo + '>';
    }
  }, {
    key: "divide",
    value: function divide() {
      if (arguments[0] instanceof DD) {
        var y = arguments[0];
        var hc = null;
        var tc = null;
        var hy = null;
        var ty = null;
        var C = null;
        var c = null;
        var U = null;
        var u = null;
        C = this._hi / y._hi;
        c = DD.SPLIT * C;
        hc = c - C;
        u = DD.SPLIT * y._hi;
        hc = c - hc;
        tc = C - hc;
        hy = u - y._hi;
        U = C * y._hi;
        hy = u - hy;
        ty = y._hi - hy;
        u = hc * hy - U + hc * ty + tc * hy + tc * ty;
        c = (this._hi - U - u + this._lo - C * y._lo) / y._hi;
        u = C + c;
        var zhi = u;
        var zlo = C - u + c;
        return new DD(zhi, zlo);
      } else if (typeof arguments[0] === 'number') {
        var _y4 = arguments[0];
        if (Double.isNaN(_y4)) return DD.createNaN();
        return DD.copy(this).selfDivide(_y4, 0.0);
      }
    }
  }, {
    key: "ge",
    value: function ge(y) {
      return this._hi > y._hi || this._hi === y._hi && this._lo >= y._lo;
    }
  }, {
    key: "pow",
    value: function pow(exp) {
      if (exp === 0.0) return DD.valueOf(1.0);
      var r = new DD(this);
      var s = DD.valueOf(1.0);
      var n = Math.abs(exp);
      if (n > 1) {
        while (n > 0) {
          if (n % 2 === 1) {
            s.selfMultiply(r);
          }
          n /= 2;
          if (n > 0) r = r.sqr();
        }
      } else {
        s = r;
      }
      if (exp < 0) return s.reciprocal();
      return s;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      if (this.isNaN()) return DD.NaN;
      var fhi = Math.ceil(this._hi);
      var flo = 0.0;
      if (fhi === this._hi) {
        flo = Math.ceil(this._lo);
      }
      return new DD(fhi, flo);
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var other = o;
      if (this._hi < other._hi) return -1;
      if (this._hi > other._hi) return 1;
      if (this._lo < other._lo) return -1;
      if (this._lo > other._lo) return 1;
      return 0;
    }
  }, {
    key: "rint",
    value: function rint() {
      if (this.isNaN()) return this;
      var plus5 = this.add(0.5);
      return plus5.floor();
    }
  }, {
    key: "setValue",
    value: function setValue() {
      if (arguments[0] instanceof DD) {
        var value = arguments[0];
        this.init(value);
        return this;
      } else if (typeof arguments[0] === 'number') {
        var _value = arguments[0];
        this.init(_value);
        return this;
      }
    }
  }, {
    key: "max",
    value: function max(x) {
      if (this.ge(x)) {
        return this;
      } else {
        return x;
      }
    }
  }, {
    key: "sqrt",
    value: function sqrt() {
      if (this.isZero()) return DD.valueOf(0.0);
      if (this.isNegative()) {
        return DD.NaN;
      }
      var x = 1.0 / Math.sqrt(this._hi);
      var ax = this._hi * x;
      var axdd = DD.valueOf(ax);
      var diffSq = this.subtract(axdd.sqr());
      var d2 = diffSq._hi * (x * 0.5);
      return axdd.add(d2);
    }
  }, {
    key: "selfAdd",
    value: function selfAdd() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof DD) {
          var y = arguments[0];
          return this.selfAdd(y._hi, y._lo);
        } else if (typeof arguments[0] === 'number') {
          var _y5 = arguments[0];
          var H = null;
          var h = null;
          var S = null;
          var s = null;
          var e = null;
          var f = null;
          S = this._hi + _y5;
          e = S - this._hi;
          s = S - e;
          s = _y5 - e + (this._hi - s);
          f = s + this._lo;
          H = S + f;
          h = f + (S - H);
          this._hi = H + h;
          this._lo = h + (H - this._hi);
          return this;
        }
      } else if (arguments.length === 2) {
        var yhi = arguments[0];
        var ylo = arguments[1];
        var _H = null;
        var _h = null;
        var T = null;
        var t = null;
        var _S = null;
        var _s = null;
        var _e = null;
        var _f = null;
        _S = this._hi + yhi;
        T = this._lo + ylo;
        _e = _S - this._hi;
        _f = T - this._lo;
        _s = _S - _e;
        t = T - _f;
        _s = yhi - _e + (this._hi - _s);
        t = ylo - _f + (this._lo - t);
        _e = _s + T;
        _H = _S + _e;
        _h = _e + (_S - _H);
        _e = t + _h;
        var zhi = _H + _e;
        var zlo = _e + (_H - zhi);
        this._hi = zhi;
        this._lo = zlo;
        return this;
      }
    }
  }, {
    key: "selfMultiply",
    value: function selfMultiply() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof DD) {
          var y = arguments[0];
          return this.selfMultiply(y._hi, y._lo);
        } else if (typeof arguments[0] === 'number') {
          var _y6 = arguments[0];
          return this.selfMultiply(_y6, 0.0);
        }
      } else if (arguments.length === 2) {
        var yhi = arguments[0];
        var ylo = arguments[1];
        var hx = null;
        var tx = null;
        var hy = null;
        var ty = null;
        var C = null;
        var c = null;
        C = DD.SPLIT * this._hi;
        hx = C - this._hi;
        c = DD.SPLIT * yhi;
        hx = C - hx;
        tx = this._hi - hx;
        hy = c - yhi;
        C = this._hi * yhi;
        hy = c - hy;
        ty = yhi - hy;
        c = hx * hy - C + hx * ty + tx * hy + tx * ty + (this._hi * ylo + this._lo * yhi);
        var zhi = C + c;
        hx = C - zhi;
        var zlo = c + hx;
        this._hi = zhi;
        this._lo = zlo;
        return this;
      }
    }
  }, {
    key: "selfSqr",
    value: function selfSqr() {
      return this.selfMultiply(this);
    }
  }, {
    key: "floor",
    value: function floor() {
      if (this.isNaN()) return DD.NaN;
      var fhi = Math.floor(this._hi);
      var flo = 0.0;
      if (fhi === this._hi) {
        flo = Math.floor(this._lo);
      }
      return new DD(fhi, flo);
    }
  }, {
    key: "negate",
    value: function negate() {
      if (this.isNaN()) return this;
      return new DD(-this._hi, -this._lo);
    }
  }, {
    key: "clone",
    value: function clone() {
      try {
        return null;
      } catch (ex) {
        if (ex instanceof CloneNotSupportedException) {
          return null;
        } else throw ex;
      } finally {}
    }
  }, {
    key: "multiply",
    value: function multiply() {
      if (arguments[0] instanceof DD) {
        var y = arguments[0];
        if (y.isNaN()) return DD.createNaN();
        return DD.copy(this).selfMultiply(y);
      } else if (typeof arguments[0] === 'number') {
        var _y7 = arguments[0];
        if (Double.isNaN(_y7)) return DD.createNaN();
        return DD.copy(this).selfMultiply(_y7, 0.0);
      }
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return Double.isNaN(this._hi);
    }
  }, {
    key: "intValue",
    value: function intValue() {
      return Math.trunc(this._hi);
    }
  }, {
    key: "toString",
    value: function toString() {
      var mag = DD.magnitude(this._hi);
      if (mag >= -3 && mag <= 20) return this.toStandardNotation();
      return this.toSciNotation();
    }
  }, {
    key: "toStandardNotation",
    value: function toStandardNotation() {
      var specialStr = this.getSpecialNumberString();
      if (specialStr !== null) return specialStr;
      var magnitude = new Array(1).fill(null);
      var sigDigits = this.extractSignificantDigits(true, magnitude);
      var decimalPointPos = magnitude[0] + 1;
      var num = sigDigits;
      if (sigDigits.charAt(0) === '.') {
        num = '0' + sigDigits;
      } else if (decimalPointPos < 0) {
        num = '0.' + DD.stringOfChar('0', -decimalPointPos) + sigDigits;
      } else if (sigDigits.indexOf('.') === -1) {
        var numZeroes = decimalPointPos - sigDigits.length;
        var zeroes = DD.stringOfChar('0', numZeroes);
        num = sigDigits + zeroes + '.0';
      }
      if (this.isNegative()) return '-' + num;
      return num;
    }
  }, {
    key: "reciprocal",
    value: function reciprocal() {
      var hc = null;
      var tc = null;
      var hy = null;
      var ty = null;
      var C = null;
      var c = null;
      var U = null;
      var u = null;
      C = 1.0 / this._hi;
      c = DD.SPLIT * C;
      hc = c - C;
      u = DD.SPLIT * this._hi;
      hc = c - hc;
      tc = C - hc;
      hy = u - this._hi;
      U = C * this._hi;
      hy = u - hy;
      ty = this._hi - hy;
      u = hc * hy - U + hc * ty + tc * hy + tc * ty;
      c = (1.0 - U - u - C * this._lo) / this._hi;
      var zhi = C + c;
      var zlo = C - zhi + c;
      return new DD(zhi, zlo);
    }
  }, {
    key: "toSciNotation",
    value: function toSciNotation() {
      if (this.isZero()) return DD.SCI_NOT_ZERO;
      var specialStr = this.getSpecialNumberString();
      if (specialStr !== null) return specialStr;
      var magnitude = new Array(1).fill(null);
      var digits = this.extractSignificantDigits(false, magnitude);
      var expStr = DD.SCI_NOT_EXPONENT_CHAR + magnitude[0];
      if (digits.charAt(0) === '0') {
        throw new IllegalStateException('Found leading zero: ' + digits);
      }
      var trailingDigits = '';
      if (digits.length > 1) trailingDigits = digits.substring(1);
      var digitsWithDecimal = digits.charAt(0) + '.' + trailingDigits;
      if (this.isNegative()) return '-' + digitsWithDecimal + expStr;
      return digitsWithDecimal + expStr;
    }
  }, {
    key: "abs",
    value: function abs() {
      if (this.isNaN()) return DD.NaN;
      if (this.isNegative()) return this.negate();
      return new DD(this);
    }
  }, {
    key: "isPositive",
    value: function isPositive() {
      return this._hi > 0.0 || this._hi === 0.0 && this._lo > 0.0;
    }
  }, {
    key: "lt",
    value: function lt(y) {
      return this._hi < y._hi || this._hi === y._hi && this._lo < y._lo;
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments[0] instanceof DD) {
        var y = arguments[0];
        return DD.copy(this).selfAdd(y);
      } else if (typeof arguments[0] === 'number') {
        var _y8 = arguments[0];
        return DD.copy(this).selfAdd(_y8);
      }
    }
  }, {
    key: "init",
    value: function init() {
      if (arguments.length === 1) {
        if (typeof arguments[0] === 'number') {
          var x = arguments[0];
          this._hi = x;
          this._lo = 0.0;
        } else if (arguments[0] instanceof DD) {
          var dd = arguments[0];
          this._hi = dd._hi;
          this._lo = dd._lo;
        }
      } else if (arguments.length === 2) {
        var hi = arguments[0];
        var lo = arguments[1];
        this._hi = hi;
        this._lo = lo;
      }
    }
  }, {
    key: "gt",
    value: function gt(y) {
      return this._hi > y._hi || this._hi === y._hi && this._lo > y._lo;
    }
  }, {
    key: "isNegative",
    value: function isNegative() {
      return this._hi < 0.0 || this._hi === 0.0 && this._lo < 0.0;
    }
  }, {
    key: "trunc",
    value: function trunc() {
      if (this.isNaN()) return DD.NaN;
      if (this.isPositive()) return this.floor();else return this.ceil();
    }
  }, {
    key: "signum",
    value: function signum() {
      if (this._hi > 0) return 1;
      if (this._hi < 0) return -1;
      if (this._lo > 0) return 1;
      if (this._lo < 0) return -1;
      return 0;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DD;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable, Comparable, Cloneable];
    }
  }], [{
    key: "sqr",
    value: function sqr(x) {
      return DD.valueOf(x).selfMultiply(x);
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      if (typeof arguments[0] === 'string') {
        var str = arguments[0];
        return DD.parse(str);
      } else if (typeof arguments[0] === 'number') {
        var x = arguments[0];
        return new DD(x);
      }
    }
  }, {
    key: "sqrt",
    value: function sqrt(x) {
      return DD.valueOf(x).sqrt();
    }
  }, {
    key: "parse",
    value: function parse(str) {
      var i = 0;
      var strlen = str.length;
      while (Character.isWhitespace(str.charAt(i))) i++;
      var isNegative = false;
      if (i < strlen) {
        var signCh = str.charAt(i);
        if (signCh === '-' || signCh === '+') {
          i++;
          if (signCh === '-') isNegative = true;
        }
      }
      var val = new DD();
      var numDigits = 0;
      var numBeforeDec = 0;
      var exp = 0;
      while (true) {
        if (i >= strlen) break;
        var ch = str.charAt(i);
        i++;
        if (Character.isDigit(ch)) {
          var d = ch - '0';
          val.selfMultiply(DD.TEN);
          val.selfAdd(d);
          numDigits++;
          continue;
        }
        if (ch === '.') {
          numBeforeDec = numDigits;
          continue;
        }
        if (ch === 'e' || ch === 'E') {
          var expStr = str.substring(i);
          try {
            exp = Integer.parseInt(expStr);
          } catch (ex) {
            if (ex instanceof NumberFormatException) {
              throw new NumberFormatException('Invalid exponent ' + expStr + ' in string ' + str);
            } else throw ex;
          } finally {}
          break;
        }
        throw new NumberFormatException("Unexpected character '" + ch + "' at position " + i + ' in string ' + str);
      }
      var val2 = val;
      var numDecPlaces = numDigits - numBeforeDec - exp;
      if (numDecPlaces === 0) {
        val2 = val;
      } else if (numDecPlaces > 0) {
        var scale = DD.TEN.pow(numDecPlaces);
        val2 = val.divide(scale);
      } else if (numDecPlaces < 0) {
        var _scale = DD.TEN.pow(-numDecPlaces);
        val2 = val.multiply(_scale);
      }
      if (isNegative) {
        return val2.negate();
      }
      return val2;
    }
  }, {
    key: "createNaN",
    value: function createNaN() {
      return new DD(Double.NaN, Double.NaN);
    }
  }, {
    key: "copy",
    value: function copy(dd) {
      return new DD(dd);
    }
  }, {
    key: "magnitude",
    value: function magnitude(x) {
      var xAbs = Math.abs(x);
      var xLog10 = Math.log(xAbs) / Math.log(10);
      var xMag = Math.trunc(Math.floor(xLog10));
      var xApprox = Math.pow(10, xMag);
      if (xApprox * 10 <= xAbs) xMag += 1;
      return xMag;
    }
  }, {
    key: "stringOfChar",
    value: function stringOfChar(ch, len) {
      var buf = new StringBuffer();
      for (var i = 0; i < len; i++) {
        buf.append(ch);
      }
      return buf.toString();
    }
  }]);
}();
export { DD as default };
DD.constructor_ = function () {
  this._hi = 0.0;
  this._lo = 0.0;
  if (arguments.length === 0) {
    this.init(0.0);
  } else if (arguments.length === 1) {
    if (typeof arguments[0] === 'number') {
      var x = arguments[0];
      this.init(x);
    } else if (arguments[0] instanceof DD) {
      var dd = arguments[0];
      this.init(dd);
    } else if (typeof arguments[0] === 'string') {
      var str = arguments[0];
      DD.constructor_.call(this, DD.parse(str));
    }
  } else if (arguments.length === 2) {
    var hi = arguments[0];
    var lo = arguments[1];
    this.init(hi, lo);
  }
};
DD.PI = new DD(3.141592653589793116e+00, 1.224646799147353207e-16);
DD.TWO_PI = new DD(6.283185307179586232e+00, 2.449293598294706414e-16);
DD.PI_2 = new DD(1.570796326794896558e+00, 6.123233995736766036e-17);
DD.E = new DD(2.718281828459045091e+00, 1.445646891729250158e-16);
DD.NaN = new DD(Double.NaN, Double.NaN);
DD.EPS = 1.23259516440783e-32;
DD.SPLIT = 134217729.0;
DD.MAX_PRINT_DIGITS = 32;
DD.TEN = DD.valueOf(10.0);
DD.ONE = DD.valueOf(1.0);
DD.SCI_NOT_EXPONENT_CHAR = 'E';
DD.SCI_NOT_ZERO = '0.0E0';